<template>
  <div class="card-footer d-flex justify-content-between align-items-center">
    <!-- Page navigation -->
    <div>
      <button
        class="text-lg border-0 outline-none mx-2 border-radius-full"
        @click="emit('changePage', pagination.currentPage - 1)"
        :disabled="!pagination.hasPrevious"
      >
        ‹
      </button>

      Page {{ pagination.currentPage }} of {{ pagination.totalPages }}

      <button
        class="text-lg border-0 outline-none mx-2 border-radius-full"
        @click="emit('changePage', pagination.currentPage + 1)"
        :disabled="!pagination.hasNext"
      >
        ›
      </button>
    </div>

    <!-- Summary -->
    <div class="text-muted">
      Showing
      {{ startRecord }}–{{ endRecord }}
      of {{ pagination.totalRecords }} records
    </div>

    <!-- Records per page -->
    <div class="d-flex align-items-center gap-2">
      <label class="form-label mb-0 me-2">Records per page:</label>
      <select
        :value="selectedPageSize"
        @change="emit('updatePageSize', +$event.target.value)"
        class="form-select form-select-sm w-auto"
      >
        <option v-for="n in pageSizeOptions" :key="n" :value="n">
          {{ n }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  pagination: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["changePage", "updatePageSize"]);

const pageSizeOptions = [5, 10, 25, 50, 100];

// Find the closest matching page size from options, or default to 10
const selectedPageSize = computed(() => {
  const currentSize = props.pagination.pageSize;
  if (!currentSize) return 10;
  
  // If current size is in options, use it
  if (pageSizeOptions.includes(currentSize)) {
    return currentSize;
  }
  
  // Otherwise, find the closest option that's >= current size, or default to 10
  const closestOption = pageSizeOptions.find(opt => opt >= currentSize) || 10;
  return closestOption;
});

const startRecord = computed(() => {
  return (props.pagination.currentPage - 1) * props.pagination.pageSize + 1;
});

const endRecord = computed(() => {
  const end = props.pagination.currentPage * props.pagination.pageSize;
  return Math.min(end, props.pagination.totalRecords);
});
</script>

<style scoped>
.form-select {
  color: #212529 !important; /* Dark text color for visibility */
}

.form-select option {
  color: #212529 !important; /* Dark text color for dropdown options */
  background-color: #ffffff !important;
}
</style>